export const WDS_V2_WIDGET_MAP = {
  BUTTON_WIDGET: "BUTTON_WIDGET_V2",
  INPUT_WIDGET_V2: "INPUT_WIDGET_V3",
};
